import { GetProfileApiResponse } from "./api/profile.api";

export const emptyProfileData: GetProfileApiResponse = {
  id: "",
  firstName: "",
  lastName: "",
  phoneNumber: {
    countryCode: "1",
    number: "",
    country: "US",
  },
  publicProfile: {
    isEnabled: false,
    publicId: "1234",
    sharePrimaryEmailAddress: false,
    shareCertifications: false,
    shareCountry: false,
    shareCredentials: false,
    shareElectiveStudies: false,
    shareJobTitle: false,
    sharePhoneNumber: false,
  },
  jobTitle: "",
  primaryEmailAddress: "email@example.com",
  avatarUrl: "",
  country: "",
  additionalEmails: [],
};
